import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/settings"));


const Settings = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default Settings;




